import React from 'react';
import PropTypes from 'prop-types';

const ReadLoader = ({ ...props }) => {
  const loaderDisplay = props.isLoading ? 'block' : 'none';

  const loaderStyle = {
    display: loaderDisplay
  };

  return <div style={loaderStyle} className={`read-loader ${props.className}`} />;
};

ReadLoader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  className: PropTypes.string
};

export default ReadLoader;
